import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Flex, Box } from 'reflexbox'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { demandsMutations } from '../../graphql/mutations'
import { servicesQueries, walletQueries, demandsQueries } from '../../graphql/queries'
import Modal from '@mui/material/Modal'
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'
import Alert from 'ui-components/lib/components/Alert'
import Switch from 'ui-components/lib/components/Switch'
import TextField from 'ui-components/lib/components/TextField'
import SelectField from 'ui-components/lib/components/SelectField'
import Typography from 'ui-components/lib/components/Typography'
import Button from 'ui-components/lib/components/Button'
import Spinner from 'ui-components/lib/components/Spinner'
import Tooltip from 'ui-components/lib/components/Tooltip'
// import Modal from 'ui-components/lib/components/Modal'
// import useModal from 'ui-components/lib/hooks/useModal'
import { faExclamationTriangle, faInfoCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFormik } from 'formik'
import { Demand } from '../../models'
import FormLoading from './FormLoading'
import { Label } from './Label'
import { PurchaseBNZ } from '../../components'
import DropzoneServices from './DropzoneServices'
import { DemandSchema } from '../../validate'
import './style.css'
const QuestionForm = (params) => {
  let demandId = params.demandId
  let serviceId = params.serviceId
  let subservice = params.subservice
  let service = params.service
  let serviceType = params.serviceType
  let awnsersFormated
  const bonuzPlan = params.bonuzPlan
  let useDraft = params.useDraft || false

  const handleDemandFinalPrice = params.handleFinalPrice

  const handleDemandUrgentDeadline = params.handleExtraUrgentDemand

  const { showMessage } = useAlertStack()
  const [extraUrgent, setExtraUrgent] = useState(null)
  const [extraLanguage, setExtraLanguage] = useState(null)
  // const [ speakLawer, setSpeakLawer] = useState(false)
  const [extraBicolumn, setExtraBicolumn] = useState(null)
  const [finalPrice, setFinalPrice] = useState(0)
  // const { isOpen, openModal, closeModal } = useModal()
  const { push } = useHistory()

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [servicePrice, setServicePrice] = useState('')
  const [subservicesQuestionsData, setSubservicesQuestionsData] = useState({})

  const [isFilesUploading, setFilesUploading] = useState(false)

  const { data: walletData, refetch: refetchMyWallet } = useQuery(walletQueries.GET_MY_WALLET)


  const findLocalStored = (questionId) => {
    let stored = localStorage.getItem('new-demand-draft');
    if (stored) {
      stored = JSON.parse(stored);
    }
    if (stored && serviceId === stored.serviceId && stored.subservice._id === subservice._id) {
      const localStored = stored.formik.answers.find(reg => reg.questionId === questionId);
      if (localStored) {
        return localStored.answer;
      }
    }
    return null
  }

  const { loading: subservicesQuestionsLoading } = useQuery(servicesQueries.GET_SUBSERVICES_QUESTIONS, {
    variables: {
      subserviceId: subservice._id,
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      const initialAnswers = data?.subServicesQuestions?.map(({ _id, required: __required, answer }) => ({
        questionId: _id,
        attachments: [],
        answer: useDraft ? findLocalStored(_id) : null,
        __required,
      }))

      formik.setValues({
        ...formik.values,
        serviceId,
        subserviceId: subservice._id,
        answers: initialAnswers,
      })

      setSubservicesQuestionsData(data);
    }
  })

  const [createDemand, { loading: loadingCreateDemand }] = useMutation((demandId !== undefined ? demandsMutations.UNDRAFT_DEMAND : demandsMutations.CREATE_DEMAND), {
    variables:{
      demandId:demandId
    },
    onCompleted() {
      if(useDraft){
        localStorage.removeItem('new-demand-draft');
      }
      showMessage({
        title: 'Serviço solicitado',
        message: 'Novo serviço solicitado com sucesso.',
        color: 'success',
        position: 'bottom-left',
        time: 4000,
      })
      push('/dashboard/serviços')
    },
    onError({ graphQLErrors }) {
      showMessage({
        title: 'Erro ao abrir serviço',
        message: graphQLErrors[0]?.extensions?.response?.body || (graphQLErrors[0]?.extensions?.response?.body?.message || 'Tente novamente mais tarde.'),
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
    },
    refetchQueries: [
      {
        query: walletQueries.GET_MY_WALLET,
      },
      {
        query: walletQueries.GET_MY_STATEMENTS,
      },
      {
        query: demandsQueries.GET_DEMANDS,
      },
    ],
  })

  const formik = useFormik({
    initialValues: new Demand(),
    validationSchema: DemandSchema,
    onSubmit: (values) => {
      createDemand({
        variables: {
          ...values,
          //remove required from answers
          answers: demandId !== undefined ? awnsersFormated:values.answers.map(({ __required: _, ...rest }) => ({
            ...rest,
          })),
          urgent: extraUrgent || false,
          bicolumn: extraBicolumn || false,
          extraLanguage: extraLanguage || false,
          draft: false
        },
      })
    },
  })

  useEffect(() => {
    setExtraUrgent(subservice?.extraUrgentPrice || false)
    setExtraLanguage(subservice?.extraLanguagePrice || false)
    setExtraBicolumn(subservice?.extraBicolumnPrice || false)

    setFinalPrice(subservice?.clientPrice?.amount || 0)
    if(handleDemandFinalPrice){
      handleDemandFinalPrice(subservice?.clientPrice?.amount || 0)
    }
    if(handleDemandUrgentDeadline){
      handleDemandUrgentDeadline(subservice?.extraUrgentPrice || false)
    }

    formik.resetForm(new Demand())
  }, [subservice]) // eslint-disable-line

  const handleQuestionChange = (event, questionIndex) => {
    const { value } = event.target
    const currentAnswers = formik.values.answers

    currentAnswers[questionIndex] = {
      ...formik.values.answers[questionIndex],
      answer: value,
    }

    formik.setValues({
      ...formik.values,
      answers: currentAnswers,
    })
  }

  const openModal = useCallback((price) => {
    setServicePrice(price)
    setModalIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setModalIsOpen(false)
    refetchMyWallet()
  }, []) // eslint-disable-line
  
  const handleExtraUrgentChange = useCallback(() => {
    const { urgentExtraBNZ: extraUrgentPrice } = subservice

    if(!extraUrgent) {
      setFinalPrice((oldPrice) => { 
        return parseInt(oldPrice) + Number(extraUrgentPrice) 
      })
      if(handleDemandFinalPrice){
        handleDemandFinalPrice((oldPrice) => { 
          return parseInt(oldPrice) + Number(extraUrgentPrice) 
        })
      }
    } else {
      setFinalPrice((oldPrice) => { 
        return parseInt(oldPrice) - Number(extraUrgentPrice) 
      })
      if(handleDemandFinalPrice){
        handleDemandFinalPrice((oldPrice) => { 
          return parseInt(oldPrice) - Number(extraUrgentPrice) 
        })
      }  
    }

    setExtraUrgent(!extraUrgent)
    handleDemandUrgentDeadline(!extraUrgent)
  }, [extraUrgent, subservice]) // eslint-disable-line

  // const handleExtraBicolumnChange = useCallback(() => {
  //   const { bicolunado: extraBicolumnPrice } = subservice

  //   if(!extraBicolumn) {
  //     setFinalPrice((oldPrice) => {
  //       return parseInt(oldPrice) + Number(extraBicolumnPrice)
  //     })
  //     if(handleDemandFinalPrice){
  //       handleDemandFinalPrice((oldPrice) => {
  //         return parseInt(oldPrice) + Number(extraBicolumnPrice)
  //       })
  //     }  
  //   } else {
  //     setFinalPrice((oldPrice) => {
  //       return parseInt(oldPrice) - Number(extraBicolumnPrice)
  //     })
  //     if(handleDemandFinalPrice){
  //       handleDemandFinalPrice((oldPrice) => {
  //         return parseInt(oldPrice) - Number(extraBicolumnPrice)
  //       })
  //     }  
  //   }

  //   setExtraBicolumn(!extraBicolumn)
  // }, [extraBicolumn, subservice]) // eslint-disable-line

  const handleExtraLanguageChange = useCallback(() => {
    const { extraLanguage: extraLanguagePrice } = subservice

    if(!extraLanguage) {
      setFinalPrice((oldPrice) => {
        return parseInt(oldPrice) + Number(extraLanguagePrice)
      })
      if(handleDemandFinalPrice){
        handleDemandFinalPrice((oldPrice) => {
          return parseInt(oldPrice) + Number(extraLanguagePrice)
        })
      }  
    } else {
      setFinalPrice((oldPrice) => {
        return parseInt(oldPrice) - extraLanguagePrice
      })
      if(handleDemandFinalPrice){
        handleDemandFinalPrice((oldPrice) => {
          return parseInt(oldPrice) - extraLanguagePrice
        })
      }  
    }

    setExtraLanguage(!extraLanguage)
  }, [extraLanguage, subservice]) // eslint-disable-line

  // const handleSpeakLawer = () => {
  //   setSpeakLawer(!speakLawer)
  // }

  const saveAsDraft = () => {
    const dados = {
      setvice: service,
      serviceId,
      subserviceId: subservice._id,
      subservice: subservice,
      serviceType: serviceType,
      extraUrgent,
      extraLanguage,
      extraBicolumn,
      draft: true,
      formik: formik.values
    };
    localStorage.setItem('new-demand-draft', JSON.stringify(dados));
    showMessage({
      title: 'Rascunho salvo',
      message: 'Rascunho salvo com sucesso.',
      color: 'success',
      position: 'bottom-left',
      time: 4000,
    })
  }

  const save = () => {
    formik.handleSubmit()
  }

  if (subservicesQuestionsLoading) return <FormLoading />

  if (!subservice.clientPrice && !subservice.needsEstimate) {
    return (
      <Flex mt={4} width={1} flexDirection="column">
        <Alert color="danger" title="Precificação de plano não atribuida" message="Contate o administrador do sistema" icon={faExclamationTriangle} />
      </Flex>
    )
  }

  if (subservicesQuestionsData?.subServicesQuestions?.length === 0 && !subservicesQuestionsLoading) {
    return (
      <Flex mt={4} width={1} flexDirection="column">
        <Alert
          color="danger"
          title="Este subserviço está indisponível"
          message="Ainda não foram adicionas perguntas ao subserviço, por favor escolha outro"
          icon={faExclamationTriangle}
        />
      </Flex>
    )
  }

  return (
    <>
      <Flex mt={2} flexDirection="column" width={1}>
        {(walletData?.wallet.balance + walletData?.wallet.creditsBonuzPlans) < finalPrice && !subservice?.needsEstimate && bonuzPlan?.subscription?.planIdentifier !== 'plano-premium' && (
          <Alert mt={1} color="danger" shortAlert style={{backgroundColor: 'var(--card-bg)', color: 'var(--text-color)', borderColor: 'var(--red-bnz)'}}>
            <Flex p={2} justifyContent="space-between" alignItems="center" width="100%">
              <Flex alignItems="center">
                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'var(--red-bnz)'}} />
                <Typography m={0} ml={2} style={{color: 'var(--text-color)'}}>
                  Seu saldo de BNZs é insuficiente para este serviço!
                </Typography>
              </Flex>
              <Flex alignItems="center">
                <Button p={2} mt={1} onClick={() => openModal(finalPrice)} color="primary" style={{backgroundColor: 'var(--blue-bnz)', color: 'var(--text-white)'}}>
                Adquirir BNZs
                </Button>
              </Flex>
            </Flex>
          </Alert>
        )}
        <form
          onSubmit={(event) => {
            event.preventDefault()
            formik.handleSubmit()
          }}
          className="card card-service"
        >
          {
            ((walletData?.wallet.balance + walletData?.wallet.creditsBonuzPlans) < finalPrice) && !subservice?.needsEstimate && bonuzPlan?.subscription?.planIdentifier !== 'plano-premium' && (
              <div className='insuficient-founds'>

              </div>
            )
          }

          {subservicesQuestionsLoading && <FormLoading />}
          <div className='card-title'>
              <h6>Formulário</h6>
          </div>
          <div className='card-body'>
            {(subservice?.urgentExtraBNZ || subservice?.bicolunado || subservice?.extraLanguage || subservice?.isDraft) && (
              <Flex flexDirection="column">
                <h6>Extras</h6>
                <Flex flexWrap="wrap" alignItems="center">
                  {(!!subservice?.urgentExtraBNZ || subservice?.isDraft) && (
                    <Box justifyContent="center" alignItems="center" mr={4}>
                      <Flex>
                        <Label>Urgente</Label>
                        <Tooltip
                          className="service-extra-tooltip"
                          ml={1}
                          direction={'bottom'}
                          text="Entregaremos o serviço em um prazo especial a você, dando prioridade máxima (você será debitado a mais)"
                        >
                          <FontAwesomeIcon style={{color: 'var(--text-secondary)'}} icon={faQuestionCircle} />
                        </Tooltip>
                      </Flex>
                      <Switch id="urgent" checked={extraUrgent} value={extraUrgent} onChange={handleExtraUrgentChange} />
                    </Box>
                  )}
                  {/* {!!subservice?.bicolunado && (
                    <Box justifyContent="center" alignItems="center" mr={4}>
                      <Flex>
                        <Label>Bicolunado</Label>
                        <Tooltip
                          ml={1}
                          text="Neste caso o documento será elaborado em dois idiomas, um português e outro de sua escolha (neste caso você será debitado a mais e favor indicar qual o segundo idioma nas perguntas)"
                        >
                          <FontAwesomeIcon style={{color: 'var(--text-secondary)'}} icon={faQuestionCircle} />
                        </Tooltip>
                      </Flex>
                      <Switch id="bicolumn" checked={extraBicolumn} value={extraBicolumn} onChange={handleExtraBicolumnChange} />
                    </Box>
                  )} */}
                  {!!subservice?.extraLanguage && (
                    <Box justifyContent="center" alignItems="center" mr={4}>
                      <Flex>
                        <Label>Idioma</Label>
                        <Tooltip
                          className="service-extra-tooltip"
                          direction={'bottom'}
                          ml={1}
                          text="O documento será inteiro em um outro idioma sem ser português (neste caso vocẽ será debitado a mais e favor indicar qual será o idioma nas perguntas)"
                        >
                          <FontAwesomeIcon style={{color: 'var(--text-secondary)'}} icon={faQuestionCircle} />
                        </Tooltip>
                      </Flex>
                      <Switch id="extraLanguage" checked={extraLanguage} value={extraLanguage} onChange={handleExtraLanguageChange} />
                    </Box>
                  )}
                  {/* <Box justifyContent="center" alignItems="center">
                    <Flex>
                      <Label>Falar com Advogado</Label>
                      <Tooltip
                        ml={1}
                        text="Call com Advogado (30min)
                        R$100,00, este valor será debitado 
                        do seu saldo BNZ. "
                      >
                        <FontAwesomeIcon color="grey" icon={faQuestionCircle} />
                      </Tooltip>
                    </Flex>
                    <Switch id="speakLawer" checked={speakLawer} value={speakLawer} onChange={handleSpeakLawer} />
                  </Box> */}
                </Flex>
              </Flex>
            )}

            <h6 className='mt-4'>Por favor, preencha o formulário abaixo:</h6>
            {subservicesQuestionsData?.subServicesQuestions &&
              !subservicesQuestionsLoading &&
              subservicesQuestionsData?.subServicesQuestions.map((question, questionIndex) => {
                return question.kind === 'text' ? (
                  <Flex key={question._id} flexDirection="column" my={3} mb={4} width={1}>
                    <Box mb={2} my={3} width={[1, 1, 1, 1]}>
                      <TextField
                        onChange={(event) => handleQuestionChange(event, questionIndex)}
                        value={formik?.values?.answers[questionIndex]?.answer}
                        mt={2}
                        label={question.description}
                        placeholder={question.tip}
                        required={question.required}
                        id={question._id}
                        error={formik?.errors?.answers?.[questionIndex]?.answer}
                        multiline
                        rows={4}
                      />
                    </Box>

                    {question.allowClientUpload && (
                      <Box width={1} key={question._id} mb={2}>
                        <DropzoneServices
                          question={question}
                          questionIndex={questionIndex}
                          formik={formik}
                          onLoad={(loading) => setFilesUploading(loading)}
                        />
                      </Box>
                    )}

                    {question.attachment && (
                      <Flex key={question._id} flexDirection="column">
                        <Label mb={4}>{question.description}</Label>
                        <a href={question.attachment} target="noopener norefer _blank" download>
                          Clique para baixar
                        </a>
                      </Flex>
                    )}
                  </Flex>
                ) : (
                  <Flex key={question._id} flexDirection="column" my={3} mb={4} width={1}>
                    <Box mb={2} width={[1, 1, 1, 1]}>
                      <SelectField
                        id={question._id}
                        onChange={(event) => handleQuestionChange(event, questionIndex)}
                        value={formik?.values?.answers[questionIndex]?._id}
                        label={question.description}
                        required={question.required}
                        mr={3}
                        error={formik?.errors?.answers?.[questionIndex]?.answer}
                      >
                        <option value="">Selecione</option>
                        {question.options?.map((option) => (
                          <option key={option} value={option} selected={formik?.values?.answers[questionIndex]?.answer === option}>
                            {option}
                          </option>
                        ))}
                      </SelectField>
                    </Box>
                    {!!question.tip && (
                      <Box mb={2} width={[1, 1, 1, 1]}>
                        <small style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>{question.tip}</small>
                      </Box>
                    )}

                    {question.allowClientUpload && (
                      <Box width={1} key={question._id} mb={2}>
                        <DropzoneServices
                          question={question}
                          questionIndex={questionIndex}
                          formik={formik}
                          onLoad={(loading) => setFilesUploading(loading)}
                        />
                      </Box>
                    )}

                    {question.attachment && (
                      <Flex key={question._id} flexDirection="column" mt={3}>
                        <Label mb={4}>{question.description}</Label>
                        <a href={question.attachment} target="noopener norefer _blank" download>
                          Clique para baixar
                        </a>
                      </Flex>
                    )}
                  </Flex>
                )
              })
            }

            <div className="question-form-actions">
              <button 
                id="save-btn-draft" 
                disabled={loadingCreateDemand || isFilesUploading} 
                className="question-form-button-draft" 
                type="button" 
                onClick={() => saveAsDraft()}
              >
                {loadingCreateDemand ? <Spinner color="primary" /> : 'Salvar como rascunho'}
              </button>
              <button 
                id="save-btn" 
                disabled={loadingCreateDemand || isFilesUploading} 
                className="question-form-button-submit" 
                type="button" 
                onClick={()=>save()}
              >
                {loadingCreateDemand ? <Spinner color="primary" /> : 'Enviar'}
              </button>
            </div>
          </div>
        </form>
        <Modal
          open={modalIsOpen}
          onClose={() => {
            closeModal()
          }}
          disableAutoFocus
          sx={{
            zIndex: '9999',
            '& .MuiBackdrop-root': {
              backgroundColor: 'var(--overlay-bg)',
            }
          }}
        >
          <PurchaseBNZ
            closeParentModal={() => {
              closeModal()
            }}
            servicePrice={servicePrice}
          />
        </Modal>        
      </Flex>
    </>
  )
}

QuestionForm.propTypes = {
  subservice: PropTypes.shape({
    id: PropTypes.string,
    needsEstimate: PropTypes.bool,
    deadline: PropTypes.number,
  }).isRequired,
  serviceId: PropTypes.string.isRequired,
}

export default QuestionForm
